import { isEntidadeS3ouS4, Papel } from "../auth/entidadeUsuario";
import { hasPermissao } from "../auth/entidadeUsuario";
import { PvBrMenuItem } from "previc-dsgov";


export const getItensDeMenu = () => {
  const todos = [Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR, Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR];
  const usuprevic = [Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR];

  let idRand = 0;

  let itens :PvBrMenuItem[] = [];
  
    if (hasPermissao(todos)){
        let sm = {
          id: "menuId"+(++idRand),
          name: "Pessoa Física",
          icon: "fas fa-user",
          children: Array<PvBrMenuItem>()
        };

        if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.ENTIDADE_ALTERAR])){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Cadastrar",
            icon: "fas fa-user",
            url: "/pessoa-fisica/cadastrar"
          });
        }
        if (hasPermissao(todos)){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Consultar",
            icon: "fas fa-user",
            url: "/pessoa-fisica/consultar"
          });
        }

        itens.push(sm);
    }

    if (hasPermissao(todos)){
        let sm = {
          id: "menuId"+(++idRand),
          name: "Diretor Executivo",
          icon: "fas fa-user",
          children: Array<PvBrMenuItem>()
        };

        if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO])){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Cadastrar Mandato",
            icon: "fas fa-user",
            url: "/dirigente/diretor/consultarpessoafisica"
          });
        }
        if (hasPermissao(todos)){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Consultar Mandato",
            icon: "fas fa-user",
            url: "/dirigente/diretor/consultar"
          });
        }

        itens.push(sm);
    }

    if (hasPermissao(todos)){
        let sm = {
          id: "menuId"+(++idRand),
          name: "Conselheiro",
          icon: "fas fa-user",
          children: Array<PvBrMenuItem>()
        };

        if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]) || isEntidadeS3ouS4() ){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Cadastrar Mandato",
            icon: "fas fa-user",
            url: "/dirigente/conselheiro/consultarpessoafisica"
          });
        }
        if (hasPermissao(todos)){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Consultar Mandato",
            icon: "fas fa-user",
            url: "/dirigente/conselheiro/consultar"
          });
        }

        itens.push(sm);
    }

    if (hasPermissao(todos)){
        let sm = {
          id: "menuId"+(++idRand),
          name: "Outros Cargos",
          icon: "fas fa-user",
          children: Array<PvBrMenuItem>()
        };

        if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.ENTIDADE_ALTERAR])){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Cadastrar",
            icon: "fas fa-user",
            url: "/outro-cargo/consultarpessoafisica"
          });
        }
        if (hasPermissao(todos)){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Consultar",
            icon: "fas fa-user",
            url: "/outro-cargo/consultar"
          });
        }

        itens.push(sm);
    }

    if (hasPermissao(todos)){
        let sm = {
          id: "menuId"+(++idRand),
          name: "Dirigente Excepcional",
          icon: "fas fa-user",
          children: Array<PvBrMenuItem>()
        };

        if (hasPermissao([Papel.DILIC_MASTER, Papel.DIFIS_CGRE])){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Cadastrar",
            icon: "fas fa-user",
            url: "/dirigente-excepcional/consultarpessoafisica"
          });
        }
        if (hasPermissao(todos)){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Consultar",
            icon: "fas fa-user",
            url: "/dirigente-excepcional/consultar"
          });
        }

        itens.push(sm);
    }


    if (hasPermissao(usuprevic)){
        let sm = {
          id: "menuId"+(++idRand),
          name: "Certificadora/Certificado",
          icon: "fas fa-user",
          children: Array<PvBrMenuItem>()
        };

        if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO])){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Cadastrar",
            icon: "fas fa-user",
            url: "/certificadoras/consultarpessoajuridica"
          });
        }
        if (hasPermissao(usuprevic)){
          sm.children.push({
            id: "menuId"+(++idRand),
            name: "Consultar",
            icon: "fas fa-user",
            url: "/certificadoras/consultarcertificadora"
          });
        }

        itens.push(sm);
    }


  return itens;
}
